module.exports = __webpack_public_path__ + "static/media/green-check2.0a244dbd.svg";